import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const hotComics = comics.slice(0, 5);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">本周最受欢迎的韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 妖精漫画免费阅读`}
                  title={`${comic.title} - 妖精漫画免费阅读韩漫`}
                  className="w-full aspect-[3/4] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {idx === 0 && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                    热门
                  </span>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-xs line-clamp-2">{comic.description}</p>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-0.5">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-xs" style={{ color: `oklch(var(--accent-500))` }}></i>
                  </div>
                  <span className="text-xs text-foreground-500">{comic.rating}</span>
                </div>
                <span className="text-xs text-foreground-400">|</span>
                <span className="text-xs text-foreground-400">{comic.tags[0]}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}